import type { RouteRecordRaw, Router } from 'vue-router'

const socialSecurityRoutes: RouteRecordRaw = {
  path: '/claim/socialSecurity',
  redirect: { name: 'SocialSecurityView' },
  children: [
    {
      path: '',
      name: 'SocialSecurityView',
      component: () => import('./views/SocialSecurityView.vue'),
      meta: {
        title: 'socialSecurity.socialSecurityClaims',
      },
    },
    {
      path: 'create',
      name: 'SocialSecurityCreateView',
      component: () => import('./views/SocialSecurityUpsertView.vue'),
      meta: {
        title: 'socialSecurity.createProperty',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:socialSecurityId',
      name: 'SocialSecurityEditView',
      component: () => import('./views/SocialSecurityUpsertView.vue'),
      meta: {
        title: 'socialSecurity.editProperty',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:socialSecurityId',
      name: 'SocialSecuritySingleView',
      component: () => import('./views/SingleSocialSecurityView.vue'),
      meta: {
        title: 'socialSecurity.ViewProperty',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(socialSecurityRoutes)
}
